var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.626 44.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H44.626V44.626H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.891,7H24.313a1.859,1.859,0,0,0,0,3.719h5.578a5.578,5.578,0,1,1,0,11.156H24.313a1.859,1.859,0,1,0,0,3.719h5.578A9.3,9.3,0,1,0,29.891,7ZM13.156,16.3a1.865,1.865,0,0,0,1.859,1.859H26.172a1.859,1.859,0,0,0,0-3.719H15.016A1.865,1.865,0,0,0,13.156,16.3Zm3.719,5.578H11.3a5.578,5.578,0,0,1,0-11.156h5.578a1.859,1.859,0,0,0,0-3.719H11.3a9.3,9.3,0,0,0,0,18.594h5.578a1.859,1.859,0,0,0,0-3.719Z",
    transform: "translate(1.719 6.016)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b59ac577.svg";
export { ForwardRef as ReactComponent };